import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import { ALL_CLIENTS } from "AppConstants";

/**
 * Controlled, presentational client-filter dropdown. Holds no state and fetches
 * nothing — each caller supplies normalised `options` ([{ id, label }]), the current
 * `value`, and an `onChange(value)` callback. When `includeAll` is true an "All"
 * option (value = ALL_CLIENTS) is prepended.
 */
export const ClientFilterSelect = ({
  value,
  onChange,
  options,
  includeAll = true,
  label = "Client",
  id = "client-filter",
  sx,
}) => (
  <TextField
    select
    id={id}
    label={label}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    InputLabelProps={{ shrink: true }}
    SelectProps={{ native: true }}
    sx={sx ?? { flex: { xs: "1 1 140px", md: "0 0 170px" }, minWidth: 0 }}
  >
    {includeAll && <option value={ALL_CLIENTS}>All</option>}
    {options.filter(Boolean).map((opt) => (
      <option key={opt.id} value={opt.id}>
        {opt.label}
      </option>
    ))}
  </TextField>
);

ClientFilterSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ).isRequired,
  includeAll: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  sx: PropTypes.object,
};

export default ClientFilterSelect;
